import { Component, OnInit } from '@angular/core';
import { version } from '../../../../../environments/version';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html'
})
export class PageNotFoundComponent implements OnInit {

  version: string;

  constructor() { }

  ngOnInit() {
    this.version = version.VERSION_CODE;
  }

}
